export const listRoutes = {
  label: 'List',
  labelDisable: true,
  children: [
    {
      name: 'List',
      active: true,
      icon: 'chart-pie',
      children: [
        {
          name: 'Documents',
          to: '/documents/list',
          active: true,
        },
        {
          name: 'Calendar Events',
          to: '/calendar-events/list',
          active: true,
        },
        {
          name: 'Upcoming Events',
          to: '/upcoming-events/list',
          active: true,
        },
        {
          name: 'Latest News',
          to: '/news/list',
          active: true,
        },
        {
          name: 'Home Banners',
          to: '/banners/list',
          active: true,
        },
        {
          name: 'Petitions',
          to: '/petitions/list',
          active: true,
        },
        {
          name: 'Members',
          to: '/members/list',
          active: true,
        },
        {
          name: 'Tenders',
          to: '/tenders/list',
          active: true,
        },
        {
          name: 'Job Vacancies',
          to: '/vacancies/list',
          active: true,
        },
        {
          name: 'Web Content',
          to: '/website-contents/list',
          active: true,
        },
      ],
    },
  ],
};

export const createRoutes = {
  label: 'Create',
  labelDisable: true,
  children: [
    {
      name: 'Create',
      active: true,
      icon: 'chart-pie',
      children: [
        {
          name: 'Document',
          to: '/documents/create',
          active: true,
        },
        {
          name: 'Calendar Event',
          to: '/calendar-events/create',
          active: true,
        },
        {
          name: 'Upcoming Event',
          to: '/upcoming-events/create',
          active: true,
        },
        {
          name: 'Latest News',
          to: '/news/create',
          active: true,
        },
        {
          name: 'Home Banner',
          to: '/banners/create',
          active: true,
        },
        {
          name: 'Member',
          to: '/members/create',
          active: true,
        },
        {
          name: 'Tender',
          to: '/tenders/create',
          active: true,
        },
        {
          name: 'Job Vacancy',
          to: '/vacancies/create',
          active: true,
        },
        {
          name: 'Web Content',
          to: '/website-contents/create',
          active: true,
        },
      ],
    },
  ],
};

const routes = [listRoutes, createRoutes];
export default routes;
